var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogistics(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 17.5a1.09 1.09 0 0 0 0-.18 2 2 0 0 0-4 0 1.09 1.09 0 0 0 0 .18 2 2 0 0 0 4 0zM11 17.5a1.09 1.09 0 0 0 0-.18 2 2 0 0 0-4 0 1.09 1.09 0 0 0 0 .18 2 2 0 0 0 4 0z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 12.75H2a.74.74 0 0 0-.39.11.75.75 0 0 0-.08 1.22.71.71 0 0 0 .47.17h2.5a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 0 0 1.5h2.76a2.68 2.68 0 0 1 .54-1.4 2.8 2.8 0 0 1 2.2-1.1 2.74 2.74 0 0 1 2.74 2.5h2.52a2.75 2.75 0 0 1 5.48 0h1.36a1 1 0 0 0 1-.8l.66-3.3a.16.16 0 0 1 0-.07.8.8 0 0 0 0-.26l-1.88-5.54a1.49 1.49 0 0 0-1.42-1h-1.8l.11-.8a1.51 1.51 0 0 0-1.49-1.7H5a.75.75 0 0 0 0 1.5h1.25a.75.75 0 0 1 0 1.5H2a.76.76 0 0 0-.75.75.74.74 0 0 0 .7.74H4.5a.75.75 0 0 1 0 1.5H2.84a.75.75 0 0 0-.59.73.75.75 0 0 0 .75.75h.5a.75.75 0 0 1 0 1.5zm14-5h1.82a.26.26 0 0 1 .24.17L21 12.25h-4.1z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogistics);
export default __webpack_public_path__ + "static/media/Logistics.88a44601e35181c35eaeac259cb052b5.svg";
export { ForwardRef as ReactComponent };